<template>
  <div class="bj-list-box">
    <Header :pageTitle="columnName">
      <template #right>
        <span class="header-bj" @click="toBj">{{
          isScholar ? "我的百家号" : "开通百家号"
        }}</span>
      </template>
    </Header>
    <van-dropdown-menu class="bj-dropdown-box" active-color="#4A79F1">
      <van-dropdown-item
        v-model="levelOne"
        :options="subjectsOption"
        @change="levelOneChange"
      />
      <van-dropdown-item
        v-model="sort"
        :options="sortOption"
        @change="sortChange"
      />
    </van-dropdown-menu>
    <van-list
      v-model="loading"
      :finished="finished"
      :error="error"
      :offset="20"
      :finished-text="list.length > 0 ? '加载完毕' : ''"
      error-text="请求失败，点击重新加载"
      @load="onLoad"
    >
      <div class="bj-list" v-if="loading || list.length > 0">
        <BjItem
          class="bj-list-item"
          v-for="item in list"
          :key="item.userId"
          :headerPhoto="item.headPhoto"
          :name="item.realName"
          :unit="item.unit"
          :research="item.researchDirection"
          @click.native="toDetail(item.userId)"
        />
      </div>
      <noneList noneType="bjList" v-else />
    </van-list>
  </div>
</template>

<script>
import Header from "@/views/mobileView/components/header";
import BjItem from "@/views/mobileView/components/listItem/bjItem.vue";
import { DropdownMenu, DropdownItem, Icon, Dialog } from "vant";
import noneList from "@/views/mobileView/components/noneList.vue";
export default {
  name: "ScholarOnline",
  components: {
    Header,
    BjItem,
    "van-dropdown-menu": DropdownMenu,
    "van-dropdown-item": DropdownItem,
    noneList,
    // "van-icon": Icon,
  },
  data() {
    return {
      isScholar: false,
      columnName: "",
      levelOne: "all",
      sort: "1",
      subjectsOption: [{ text: "全部", value: "all" }],
      sortOption: [{ text: "综合", value: "1" }],
      params: {
        pageNo: 0,
        pageSize: 20,
        // sort: "1",
        // subjects: {
        //   levelOne: "",
        // },
      },
      list: [],
      loading: false,
      finished: false,
      error: false,
    };
  },
  created() {
    this.getColumnName();
    this.getSubjectsOptionList();
    if (sessionStorage.getItem("token")) {
      // 展示右上角按钮内容 -- 学者是我的百家号 -- 其他是开通百家号
      let userInfo = JSON.parse(sessionStorage.getItem("userInfo"));
      let customerType = userInfo.user.customerType; // 1 普通用户 2学者 4 期刊 5 机构 没有 子账号
      this.isScholar = customerType === 2;
    }
  },
  methods: {
    // 学科分类选择触发
    levelOneChange(value) {
      if (value === "all") {
        delete this.params.subjects;
      } else {
        this.params.subjects = { levelOne: value };
      }
      this.params.pageNo = 1;
      this.list = [];
      this.getList();
    },
    sortChange(value) {
      console.log(value, "sortChange");
    },
    // 跳转我的百家号
    toBj() {
      if (sessionStorage.getItem("token")) {
        let userInfo = JSON.parse(sessionStorage.getItem("userInfo"));
        let customerType = userInfo.user.customerType; // 1 普通用户 2学者 4 期刊 5 机构 没有 子账号
        let id = userInfo.user.id; // 1 普通用户 2学者 4 期刊 5 机构 没有 子账号
        if (customerType == 1) {
          this.$router.push("/authentication"); // 跳转认证页面
        } else if (customerType == 2) {
          this.$router.push({
            path: "/appusesbaijia",
            query: {
              item: 0,
              id,
            },
          });
        } else {
          Dialog.alert({
            message: "已开通百科/机构号，如需开通百家号，请更换账号后重试",
            theme: "round-button",
            getContainer: ".bj-list-box",
          });
        }
      } else {
        this.$router.push("/logins");
      }
    },
    // 获取栏目名称 (百家id为8)
    async getColumnName() {
      const resp = await this.$apis.searchServe.getNavList();
      resp.data.forEach((item) => {
        if (item.id === "8") this.columnName = item.columnName;
      });
    },
    // 获取学科分类选项列表
    async getSubjectsOptionList() {
      const res = await this.$apis.hundredServe.getOneList();
      let options = res.researchOneList.map((item) => {
        return {
          text: item.subjectName,
          value: item.id,
        };
      });
      this.subjectsOption.push(...options);
    },
    // 触底加载
    onLoad() {
      this.params.pageNo += 1;
      this.getList();
    },
    // 获取列表
    async getList() {
      this.loading = true;
      const resp = await this.$apis.hundredServe.getFamilyList(this.params);
      if (resp.resultCode == 200) {
        this.finished = resp.data.list.length < 20;
        this.list.push(...resp.data.list);
      } else {
        this.error = true;
      }
      this.loading = false;
    },
    // 点击进入详情页
    toDetail(id) {
      this.$router.push({
        path: "/appusesbaijia",
        query: {
          item: 0,
          id,
        },
      });
    },
  },
};
</script>

<style scoped lang="scss">
.bj-list-box {
  padding-top: 44px;
  min-height: 100vh;
  background-color: #f5f5f5;
  .header-bj {
    font-size: 15px;
    color: #333333;
  }
  .bj-dropdown-box {
    &::v-deep .van-dropdown-menu__title {
      &::after {
        content: "\e65e";
        margin-top: -6px;
        right: -10px;
        font: normal normal normal 14px/1 vant-icon;
        border: none;
        transform: rotate(0deg);
      }
    }
    &::v-deep .van-dropdown-menu__title--down {
      &::after {
        margin-top: -6px;
        transform: rotate(180deg);
      }
    }
  }
  .bj-list {
    padding: 0 12px;
    overflow: hidden;
    .bj-list-item {
      margin: 12px 0;
      padding: 15px 12px;
      width: 100%;
      border-radius: 8px;
      background-color: #fff;
      overflow: hidden;
    }
  }
  &::v-deep .van-button {
    color: #4a79f1;
    background: #fff;
    border: 1px solid #4a79f1;
  }
}
</style>
